// client/src/components/command/CommandStatsCards.jsx
// Stats overview cards for the Command batch workflow.

import React from "react";

const cardStyles = {
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
        gap: "12px",
        marginBottom: "20px",
    },
    card: (accent) => ({
        background: "linear-gradient(135deg, #1a1f2e 0%, #151921 100%)",
        borderRadius: "12px",
        padding: "16px",
        border: `1px solid ${accent}22`,
        borderTop: `3px solid ${accent}`,
    }),
    label: {
        color: "#94a3b8",
        fontSize: "11px",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
    },
    value: (accent) => ({
        color: accent,
        fontSize: "28px",
        fontWeight: 800,
        fontVariantNumeric: "tabular-nums",
        marginTop: "4px",
        lineHeight: 1,
    }),
};

const cards = [
    { key: "total", label: "Total Orders", accent: "#8b5cf6", icon: "📦" },
    { key: "validated", label: "Validated", accent: "#06b6d4", icon: "🔍" },
    { key: "location_mismatch", label: "Mismatches", accent: "#ef4444", icon: "🚨" },
    { key: "location_ok", label: "Location OK", accent: "#10b981", icon: "✅" },
    { key: "pending_cancel", label: "To Cancel", accent: "#f59e0b", icon: "⚠️" },
    { key: "executed", label: "Executed", accent: "#6366f1", icon: "⚡" },
    { key: "executed_ok", label: "Exec Success", accent: "#22c55e", icon: "🎯" },
    { key: "not_found", label: "Not Found", accent: "#94a3b8", icon: "❓" },
];

export default function CommandStatsCards({ stats }) {
    if (!stats) return null;

    return (
        <div style={cardStyles.grid}>
            {cards.map(({ key, label, accent, icon }) => (
                <div key={key} style={cardStyles.card(accent)}>
                    <div style={cardStyles.label}>{icon} {label}</div>
                    <div style={cardStyles.value(accent)}>{(stats[key] ?? 0).toLocaleString()}</div>
                </div>
            ))}
        </div>
    );
}
